'use client'
import { StorageService } from '@dynamic-labs/utils';
import { AUTH_EXPIRES_AT } from '../../constants/localStorage.js';

const getExpiresAt = () => StorageService.getItem(AUTH_EXPIRES_AT);

export { getExpiresAt };
